import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { Button } from 'antd'
import React, { FC, useState } from 'react'
import { globalToaster } from 'components/elements/global'
import { useConfirmPaymentSuccessMutation } from '../api'
import CreditsPaymentSummary from './CreditsPaymentSummary'
import { TCreditPaymentDetails } from '../types'

const PurchasePaymentBlock: FC<{
 onSuccuss?: () => void
 purchaseData?: TCreditPaymentDetails
}> = ({ purchaseData, onSuccuss }): JSX.Element => {
 const stripe = useStripe()
 const elements = useElements()
 const [confirmPaymentSuccess] = useConfirmPaymentSuccessMutation()

 const [isLoading, setIsLoading] = useState(false)
 const handleSubmit = async (e: any): Promise<void> => {
  e.preventDefault()
  if (!stripe || !elements) {
   return
  }

  setIsLoading(true)

  const result = await stripe.confirmPayment({
   elements,
   redirect: 'if_required',
  })

  // This checks for immediate errors (e.g., card declined)
  if (
   result.error?.type === 'card_error' ||
   result.error?.type === 'validation_error'
  ) {
   globalToaster({
    content: result.error.message,
    type: 'error',
   })
  } else {
   try {
    if (purchaseData) {
     const { message, status } = await confirmPaymentSuccess({
      payment_intent_id: result.paymentIntent?.id as string,
      plan_id: purchaseData.plan_id,
     }).unwrap()
     if (status === 'success') {
      globalToaster({
       content: message,
       type: 'success',
      })
      onSuccuss?.()
     } else {
      globalToaster({
       content: message,
       type: 'error',
      })
     }
    }
   } catch (err) {
    console.log(err)
    globalToaster({
     content:
      'Payment succeeded but failed to confirm. Please contact support.',
     type: 'error',
    })
   }
  }

  setIsLoading(false)
 }

 return (
  <div className="credit-pyament-section">
   {purchaseData && <CreditsPaymentSummary data={purchaseData} />}
   <form id="payment-form" onSubmit={handleSubmit}>
    <PaymentElement options={{ layout: 'tabs' }} id="payment-element" />
    <Button
     disabled={isLoading || !stripe || !elements}
     loading={isLoading}
     id="submit"
     htmlType="submit"
     type="primary"
     className="w-100 mt-3"
    >
     <span id="button-text">Pay now</span>
    </Button>
    {/* Show any error or success messages */}
    {/* {message && <div id="payment-message">{message}</div>} */}
   </form>
  </div>
 )
}

export default PurchasePaymentBlock
